/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';

import { MainCoreModuleProvider, MainApp } from './components';

import type { MainCoreModuleConfig } from '../../../core-modules/main-core-module';

export interface MainRootProps {
    coreModuleConfig: MainCoreModuleConfig;
}

export const MainRoot: React.FC<MainRootProps> = ({ coreModuleConfig }) => (
    <MainCoreModuleProvider coreModuleConfig={coreModuleConfig}>
        <MainApp />
    </MainCoreModuleProvider>
);
